import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/[locale]/(root)/blogs/components/BlogCard.tsx");
